export default "__VITE_ASSET__Blli1Tq$__"